import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { SoftButton, cls, useDialogPaperSx } from "../hatim/soft/SoftKit";

/** Hedef silme onayı; yükleme sürerken kapatılamaz. */
export default function ConfirmDeleteGoal({ open, label, loading, onCancel, onConfirm }) {
  const { t } = useScriptMode();
  const paperSx = useDialogPaperSx();
  return (
    <Dialog
      open={!!open}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: paperSx }}
      sx={{ zIndex: 1500 }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>{t("my_goals_delete_title")}</DialogTitle>
      <DialogContent>
        <p className={`text-sm ${cls.muted}`}>{t("my_goals_delete_body", { label: label || "" })}</p>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <SoftButton tone="cancel" onClick={onCancel} disabled={loading}>
          {t("cancel")}
        </SoftButton>
        <SoftButton tone="danger" onClick={onConfirm} disabled={loading}>
          {t("delete")}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}
